import { render, staticRenderFns } from "./SavedInputLong.vue?vue&type=template&id=3525eccb&scoped=true&"
import script from "./SavedInputLong.vue?vue&type=script&lang=js&"
export * from "./SavedInputLong.vue?vue&type=script&lang=js&"
import style0 from "./SavedInputLong.vue?vue&type=style&index=0&id=3525eccb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3525eccb",
  null
  
)

export default component.exports